import { Component } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";

import { RegistrationService } from "../registration-service/registration.service";
import { AuthenticationService } from "../../common/authentication/authentication.service";

@Component({
	selector: "sdp-invalid-code",
	templateUrl: "./invalid-code.component.html"
})
export class InvalidCodeComponent {
	private email = "";
	public errorMessage = "";

	constructor(
		private route: ActivatedRoute,
		public registrationService: RegistrationService,
		private auth: AuthenticationService
	) {
		this.route.queryParams.subscribe((params: Params) => {
			this.email = params["email"];
		});
	}

	public showSignInForm() {
		this.registrationService.navigateToLogin();
	}

	public async resendConfirmationEmail() {
		if (this.email) {
			this.registrationService.submitLoaderVisible(true);
			try {
				await this.auth.resendRegistrationConfirmation(this.email);
				this.registrationService.navigateToRegisterConfirm();
			} catch (e) {
				this.errorMessage = "error.message.sendingNewConfirmationEmail";
			} finally {
				this.registrationService.submitLoaderVisible(false);
			}
		} else {
			// somehow they got onto the page with the resend link, but we never got what their email was
			// in this case just show them the login page and move on
			this.showSignInForm();
		}
	}
}
